import { IElementRectProps } from '../shared/interfaces';

export const getElementRect = (element: HTMLElement): IElementRectProps => {
    const box = element.getBoundingClientRect();

    const { body, documentElement } = document;

    const clientTop = documentElement.clientTop || body.clientTop || 0;
    const clientLeft = documentElement.clientLeft || body.clientLeft || 0;

    const top = box.top + window.scrollY - clientTop;
    const left = box.left + window.scrollX - clientLeft;

    return {
        top: Math.round(top),
        left: Math.round(left),
        width: box.width,
        height: box.height,
    };
};
